<div class="vox-inline-message vox-inline-message_light-grey" *ngIf="form.value?.length === 0">
  <div>
    <i class="icon-small-info"></i>
    <span translate>company.integrations.edit.form.user_mapping-component.empty</span>
  </div>
</div>
<div class="mapping-container" *ngFor="let m of form.controls; let i = index;">
  <!-- user -->
  <div class="user-selector">
    <label class="vox-field-label" *ngIf="i === 0">
      {{'company.integrations.edit.form.user_mapping-component.label-left' | translate}}
    </label>
    <div class="vox-dropdown-input dropdown" ngbDropdown>
      <div type="button" class="dropdown-toggle" ngbDropdownToggle>
        <span *ngIf="m.value.user; else noData">{{m.value.user.first_name}} {{m.value.user.last_name}}</span>
        <span class="caret"></span>
      </div>
      <ul class="custom-integration-select-team-dropdown-menu dropdown-menu" ngbDropdownMenu>
        <ng-container *ngIf="availableUsers?.length > 0; else noUsers">
          <li *ngFor="let user of availableUsers" (click)="selectUser(user, i)" class="dropdown-item" ngbDropdownItem>
            {{user.first_name}} {{user.last_name}}
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <!-- platform user -->
  <div class="user-selector">
    <label class="vox-field-label" *ngIf="i === 0" translate>
      {{'company.integrations.edit.form.user_mapping-component.label-right' | translate: { crm: connection.name } }}
    </label>
    <div class="vox-dropdown-input dropdown" ngbDropdown>
      <div type="button" class="dropdown-toggle" ngbDropdownToggle>
        <span *ngIf="m.value.platform_user; else noData">{{m.value.platform_user.first_name}}
          {{m.value.platform_user.last_name}}</span>
        <span class="caret"></span>
      </div>
      <ul class="custom-integration-select-team-dropdown-menu dropdown-menu" ngbDropdownMenu>
        <ng-container *ngIf="availableCrmUsers?.length > 0; else noUsers">
          <li *ngFor="let user of availableCrmUsers" (click)="selectCrmUser(user,i)" class="dropdown-item" ngbDropdownItem>
            {{user.first_name}} {{user.last_name}}
          </li>
        </ng-container>
      </ul>
    </div>
  </div>

  <ng-template #noData><span>-</span></ng-template>

  <ng-template #noUsers>
    <li class="dropdown-item disabled" translate ngbDropdownItem>company.integrations.edit.form.user_mapping-component.no-users</li>
  </ng-template>

  <button class="vox-btn vox-btn-secondary-grey" type="button" (click)="removeMapping(i)"><i
      class="icon-small-delete"></i></button>
</div>
<div class="add-mapping-container m-t-md">
  <span class="m-r-sm" translate>company.integrations.edit.form.user_mapping-component.add-mapping</span>
  <button class="vox-btn vox-btn-secondary"
    type="button"
    [disabled]="availableUsers?.length === 0 || availableCrmUsers?.length === 0"
    (click)="addMapping()">
    <i class="icon-small-add"></i>
  </button>
</div>